import { render, staticRenderFns } from "./NoReplacementCard.vue?vue&type=template&id=756b4b70&"
import script from "./NoReplacementCard.vue?vue&type=script&lang=js&"
export * from "./NoReplacementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports